import styled, { css } from 'styled-components';

import { TransientProps } from '@common/types';

export const Container = styled.div`
  position: relative;
`;

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  height: 2.5rem;
  padding: 0 0.5rem;
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  border-radius: 0.25rem;
  transition: background 0.2s ease;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;

  svg {
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &:active {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  bottom: calc(100% + 0.5rem);
  right: 0;
  min-width: 8rem;
  background: rgba(20, 20, 20, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 0.5rem;
  overflow: hidden;
  z-index: 30;
`;

type OptionProps = TransientProps<{ active: boolean }>;

export const Option = styled.button<OptionProps>`
  ${({ $active }) => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.625rem 0.75rem;
    background: ${$active ? 'rgba(255, 255, 255, 0.15)' : 'transparent'};
    border: none;
    color: #fff;
    font-size: 0.8125rem;
    font-weight: ${$active ? 600 : 400};
    cursor: pointer;
    transition: background 0.15s ease;
    text-align: left;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    &:not(:last-child) {
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    }
  `}
`;
